export default __webpack_public_path__ + "06eb4eb9cdc3b93cc07fc8db65f492c2.mp3";